import base from './base'
//TODO change file name to base.ts to enable typescript
export default {
    getProducts () {
        return base.get('products')
    },

    getProductSettings (productIdentifier) {
        return base.get(`/products/${productIdentifier}/settings`)
    },

    updateProductSettings(productIdentifier, data) {
        return base.put(`/products/${productIdentifier}/settings`, data)
    },

}